import ReactGA from 'react-ga4'

/**
 * Marketing događaji namjerno imaju jednu kategoriju i stabilna imena.
 * Tako se u GA4 može uspoređivati ponašanje po jeziku, ruti i paketu.
 */
export const trackMarketingEvent = (action: string, label?: string): void => {
	ReactGA.event({
		category: 'marketing',
		action,
		label
	})
}
